import { createAsyncThunk } from '@reduxjs/toolkit';
import companyApi from '~/apis/company';
import { GET_SELECTION_COMPANY } from '~/utils/constants/actionType';
import { IResponseCompany } from '~/utils/interface/company';

export const handleGetSelectionCompanies = createAsyncThunk<IResponseCompany>(
  GET_SELECTION_COMPANY,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await companyApi.getSelectCompany();

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
